import { useRoutePageContext } from "@components/ui/route-page-context"
import type { SupportedLocale as Lang } from "@site-types/content"
import { createContext, useContext } from "react"

export const SendMailLangContext = createContext<Lang | undefined>(undefined)

export function useSendMailLang() {
  const providedLang = useContext(SendMailLangContext)
  if (providedLang) return providedLang

  const { locale } = useRoutePageContext()

  return locale
}
